const bookingConfig = {
  booking: {
    displayDurationDays: false,
  },
}

export default bookingConfig
